<template>
  <div>
    <ul class="ztree">
      <yejin-tree-core
        v-for="(node, index) in isMoreTreeData"
        :key="index"
        :checkBoxType="checkBoxType"
        :allOpen="allOpen"
        :beforeClick="beforeClick"
        :checkBox="checkBox"
        :nodeTrigger="nodeTrigger"
        :index="index"
        :tree="node"
        :first="index === 0"
        :last="treeData.length - 1 === index"
        :currentArray="treeData"
        :parentTree="node.parentTree"
        :rootData="treeData"
        :checkBoxCallInit="checkBoxCallInit"
        :checkBoxCall="checkBoxCall"
        :clickNode="clickNode"
        :hiddenLine="hiddenLine"
        :async="async"
        :isAllCheck="isAllCheck"
        :asyncCall="asyncCall"
        :isShowResourceNum="isShowResourceNum"
        :textMaxLength="textMaxLength"
      />
      <div v-if="treeData.length > 3 && !defaultMore" class="flexRow align-center isMore">
        <span class="cursor" @click="isMore = !isMore">
          {{ isMore ? "收起" : "展开" }}
          <van-icon class="icon" :class="{ up: isMore }" name="arrow-down" />
        </span>
      </div>
    </ul>
  </div>
</template>

<script>
import YejinTreeCore from "@/components/yejin/tree/yejin-tree-core.vue"

export default {
  components: { YejinTreeCore },
  name: "yejin-tree",
  props: {
    treeNode: {
      type: Array,
      default: function () {
        return []
      },
      required: true,
    },
    allOpen: {
      type: Boolean,
      default: null,
      required: false,
    },
    nodeTrigger: {
      type: Boolean,
      default: false,
      required: false,
    },
    checkBox: {
      type: Boolean,
      default: true,
      required: false,
    },
    // 不关联
    checkBoxType: {
      type: Boolean,
      default: false,
      required: false,
    },
    beforeClick: {
      type: Function,
      default: null,
    },
    clickNode: {
      type: Function,
    },
    asyncCall: {
      type: Function,
    },
    hiddenLine: {
      type: Boolean,
      default: true,
      required: false,
    },
    async: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 是否显示资源数量
    isShowResourceNum: {
      type: Boolean,
      default: true,
      required: false,
    },
    // 是否全选
    isAllCheck: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 单号最大显示几个字
    textMaxLength: {
      type: Number,
      default: 13,
    },
    defaultMore: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      treeData: [],
      line: "",
      first: true,
      allOpens: this.allOpen,
      checkedBoxCallArr: [],
      isMore: false,
    }
  },
  computed: {
    isMoreTreeData() {
      return this.isMore || this.defaultMore ? this.treeData : this.treeData.slice(0, 3)
    },
  },
  methods: {
    init() {
      let tempList = JSON.parse(JSON.stringify(this.treeNode))

      let initTree = (tree, parent) => {
        for (let index = 0; index < tree.length; index++) {
          let m = tree[index]
          m.id = m.Id
          m.name = m.Title
          //tree.forEach((m, index) => {
          if (!m.hasOwnProperty("id")) {
            m.id = m.hasOwnProperty("id") ? m.id : null
          }
          if (!m.hasOwnProperty("open")) {
            m.open = m.hasOwnProperty("open") ? m.open : false
          }
          if (!m.hasOwnProperty("checked")) {
            m.checked = m.hasOwnProperty("checked") ? m.checked : false
          }
          if (!m.hasOwnProperty("checkBox")) {
            m.checkBox = m.hasOwnProperty("checkBox") ? m.checkBox : false
          }
          if (!m.hasOwnProperty("nodeTrigger")) {
            m.nodeTrigger = m.hasOwnProperty("nodeTrigger") ? m.nodeTrigger : false
          }
          if (!m.hasOwnProperty("checkBoxType")) {
            m.checkBoxType = this.checkBoxType
          }
          if (!m.hasOwnProperty("last")) {
            m.last = m.hasOwnProperty("last") ? m.last : false
          }
          if (!m.hasOwnProperty("first")) {
            m.first = m.hasOwnProperty("first") ? m.first : false
          }
          if (!m.hasOwnProperty("active")) {
            m.active = m.hasOwnProperty("active") ? m.active : false
          }
          if (!m.hasOwnProperty("async")) {
            m.async = this.async
          }
          if (!m.hasOwnProperty("hiddenLine")) {
            m.hiddenLine = this.hiddenLine
          }
          if (!m.hasOwnProperty("parentTree")) {
            m.parentTree = parent ? parent : null
          }

          m.children = m.children || []
          if (m.children.length > 0) initTree(m.children, m)
          //});
        }
      }
      initTree(tempList, null)

      this.treeData = tempList
      this.line = "line"
      if (this.first) this.$emit("call", this.treeData)
    },
    changeOpenStatus() {
      let changeOpen = data => {
        data.forEach(d => {
          d.open = this.allOpen
          if (d.children) changeOpen(d.children)
        })
      }
      changeOpen(this.treeData)
    },
    checkBoxCallInit(arr) {
      console.log(arr, "arr")

      arr.forEach(a => {
        this.checkedBoxCallArr.push(a)
      })
    },
    checkBoxCall(arr, isAdd) {
      if (isAdd)
        arr.forEach(a => {
          this.checkedBoxCallArr.push(a)
        })
      else {
        arr.forEach(a => {
          if (this.checkBoxCall.length === 0) return
          let key = (a.id ? a.id : null) + a.index + a.name

          console.log("checkBoxCall", key)
          this.checkedBoxCallArr.forEach((ss, index) => {
            if ((ss.id ? ss.id : null) + ss.index + ss.name === key) {
              this.checkedBoxCallArr.splice(index, 1)
            }
          })
        })
      }
      this.$emit("checkBoxCall", this.checkedBoxCallArr)
    },

    // 仅限一级全选
    checkBoxAll() {
      this.checkedBoxCallArr = []
      this.treeData = this.treeData.map(item => {
        item.checked = true
        this.checkedBoxCallArr.push(item)
        return item
      })
    },
    // 重置
    reset() {
      console.log(this.treeData)
      this.checkedBoxCallArr = []
      let clearStyle = data => {
        data.forEach(d => {
          d.checked = false
          if (d.children) {
            clearStyle(d.children)
          }
        })
      }
      clearStyle(this.treeData)

      this.$emit("checkBoxCall", this.checkedBoxCallArr)
    },
  },
  created() {
    // this.init();
  },
  update() {
    // this.init();
  },
  mounted() {
    /*Vue.nextTick(() => {
     this.init();
     });*/
    /*复选框回调*/
    this.$emit("checkBoxCall", this.checkedBoxCallArr)
  },
  watch: {
    allOpen() {
      this.changeOpenStatus()
    },
    treeNode: {
      handler() {
        this.init()
      },
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
@import "@/assets/scss/tree.less";
.isMore {
  font-size: 14px;
  color: #8d9399;
  .icon {
    font-size: 12px;
    transition: all 0.3s;
  }
  .up {
    transform: rotate(180deg) !important;
  }
}
</style>
